<script>
    import { SERVICE_STATE, SERVICE_STATE_LABELS } from '@/enums/ServiceState';

    const DAYS = 90;

    export default {
        props: {
            state: {
                type: Number,
                default: SERVICE_STATE.OPERATIONAL
            }
        },
        computed: {
            bars() {
                // We do not record uptime history yet, so every day except today is a placeholder.
                // TODO: replace the placeholders with real per-day results once probe outcomes are persisted.
                const bars = [];

                for (let day = 0; day < DAYS - 1; day++) bars.push({ state: SERVICE_STATE.OPERATIONAL, isPlaceholder: true });

                bars.push({ state: this.state, isPlaceholder: false });

                return bars;
            },
            todayLabel() {
                return SERVICE_STATE_LABELS[this.state] ?? 'Unknown';
            }
        },
        methods: {
            barClass(bar) {
                return {
                    'is-placeholder': bar.isPlaceholder,
                    'is-degraded': bar.state === SERVICE_STATE.DEGRADED,
                    'is-down': bar.state === SERVICE_STATE.DOWN
                };
            },
            barTitle(bar) {
                return bar.isPlaceholder ? 'No data recorded' : `Today — ${this.todayLabel}`;
            }
        }
    };
</script>

<template>
    <div>
        <div class="uptime-bars" role="img" :aria-label="`Uptime history is not recorded yet. Today: ${todayLabel}.`">
            <span v-for="(bar, i) in bars" :key="`uptime-bar-${i}`" class="uptime-bar" :class="barClass(bar)" :title="barTitle(bar)"></span>
        </div>
        <div class="uptime-legend">
            <span>90 days ago</span>
            <span class="uptime-legend-rule"></span>
            <span>Today</span>
        </div>
    </div>
</template>

<style lang="scss" scoped>
    @import '@/styles/_status-colors.scss';

    .uptime-bars {
        display: flex;
        align-items: stretch;
        gap: 2px;
        height: 34px;
    }

    .uptime-bar {
        flex: 1 1 0;
        min-width: 2px;
        border-radius: 1px;
        background-color: $status-operational;

        &.is-placeholder {
            opacity: 0.85;
        }

        &.is-degraded {
            background-color: $status-degraded;
        }

        &.is-down {
            background-color: $status-down;
        }
    }

    .uptime-legend {
        display: flex;
        align-items: center;
        gap: 0.75rem;
        margin-top: 0.5rem;
        font-size: 0.8125rem;
        color: #9b9b9b;

        .uptime-legend-rule {
            flex: 1 1 auto;
            height: 1px;
            background-color: #e3e3e3;
        }
    }
</style>
